import React from 'react'
import { Box, Switch, Text } from '../../../components'
import { fontSizes } from '../../../components/chakraThemeExtension'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import { brandColors } from 'shared/basicPalette'
import SVG from 'react-inlinesvg'

type CampaignActionToggleRowProps = {
  title: string
  description: React.ReactElement
  tooltip?: string
  disabled?: boolean
  checked: boolean
  icon: string
  onChange: () => void
}

export const CampaignActionToggleRow: React.FC<CampaignActionToggleRowProps> =
  ({
    title,
    description,
    icon,
    children,
    disabled,
    onChange,
    checked,
    tooltip
  }) => {
    return (
      <section css={{ width: '100%', alignItems: 'top', display: 'flex' }}>
        <SVG
          className="element-icon"
          src={icon}
          width={'24px'}
          height={'24px'}
          color={brandColors.grey[500]}
          css={{
            width: '44px',
            height: '44px',
            backgroundColor: brandColors.white,
            padding: '10px',
            borderRadius: '50%'
          }}
        />
        <Box textAlign="left" ml="1rem" flex={1}>
          <Text
            fontSize={fontSizes.xl}
            fontWeight="500"
            color={brandColors.black}
          >
            {title}
          </Text>
          <Box pr={'0.5rem'}>
            <Text fontSize={fontSizes.md} mt={2}>
              {description}
            </Text>
          </Box>
        </Box>
        <Tooltip text={tooltip}>
          <Switch
            isDisabled={disabled}
            isChecked={checked}
            onChange={onChange}
          />
        </Tooltip>
        {children}
      </section>
    )
  }
